import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { SiPython, SiTensorflow, SiPytorch, SiOpenai, SiMongodb, SiPostgresql, SiDocker, SiKubernetes, SiAmazonaws, SiMicrosoftazure, SiGooglecloud, SiReact, SiNodedotjs, SiDjango, SiFlask, SiFastapi } from 'react-icons/si';
import './Technologies.css';

const Technologies = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  const techCategories = [
    {
      category: "AI & Machine Learning",
      technologies: [
        { name: "Python", icon: <SiPython />, color: "#3776AB" },
        { name: "TensorFlow", icon: <SiTensorflow />, color: "#FF6F00" },
        { name: "PyTorch", icon: <SiPytorch />, color: "#EE4C2C" },
        { name: "OpenAI", icon: <SiOpenai />, color: "#412991" }
      ]
    },
    {
      category: "Databases",
      technologies: [
        { name: "MongoDB", icon: <SiMongodb />, color: "#47A248" },
        { name: "PostgreSQL", icon: <SiPostgresql />, color: "#336791" }
      ]
    },
    {
      category: "DevOps & Cloud",
      technologies: [
        { name: "Docker", icon: <SiDocker />, color: "#2496ED" },
        { name: "Kubernetes", icon: <SiKubernetes />, color: "#326CE5" },
        { name: "AWS", icon: <SiAmazonaws />, color: "#FF9900" },
        { name: "Azure", icon: <SiMicrosoftazure />, color: "#0078D4" },
        { name: "Google Cloud", icon: <SiGooglecloud />, color: "#4285F4" }
      ]
    },
    {
      category: "Web Development",
      technologies: [
        { name: "React", icon: <SiReact />, color: "#61DAFB" },
        { name: "Node.js", icon: <SiNodedotjs />, color: "#339933" },
        { name: "Django", icon: <SiDjango />, color: "#092E20" },
        { name: "Flask", icon: <SiFlask />, color: "#000000" },
        { name: "FastAPI", icon: <SiFastapi />, color: "#009688" }
      ]
    }
  ];

  return (
    <section id="technologies" className="section technologies" ref={ref}>
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: -50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2>Technologies We Master</h2>
          <p>Leveraging cutting-edge tools and frameworks to build powerful solutions</p>
        </motion.div>

        <div className="tech-categories">
          {techCategories.map((category, catIndex) => (
            <motion.div
              key={catIndex}
              className="tech-category"
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: catIndex * 0.2 }}
            >
              <h3 className="category-title">{category.category}</h3>
              <div className="tech-grid">
                {category.technologies.map((tech, techIndex) => (
                  <motion.div
                    key={techIndex}
                    className="tech-card glass"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={inView ? { opacity: 1, scale: 1 } : {}}
                    transition={{ duration: 0.4, delay: catIndex * 0.2 + techIndex * 0.1 }}
                    whileHover={{ 
                      scale: 1.1,
                      y: -10,
                      transition: { duration: 0.2 }
                    }}
                  >
                    <motion.div 
                      className="tech-icon"
                      style={{ color: tech.color }}
                      whileHover={{ rotate: 360 }}
                      transition={{ duration: 0.6 }}
                    >
                      {tech.icon}
                    </motion.div>
                    <p className="tech-name">{tech.name}</p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="tech-footer"
          initial={{ opacity: 0 }}
          animate={inView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 1 }}
        >
          <p>And many more technologies tailored to your specific needs...</p>
        </motion.div>
      </div>
    </section>
  );
};

export default Technologies;
